import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { api } from 'src/app/@shared/services/api';
import { CommonService } from 'src/app/@shared/services/common.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent extends BaseClass<any> implements OnInit {
  @ViewChild('editModal', { static: false }) editModal?: ModalDirective;
  public data: any;
  public user: any;
  public updateProfileId: any;
  public updateProfileName: any = '';
  private uId: any;
  private tId: any;
  private key: any;
  public search: any = '';
  modalRef?: BsModalRef

  constructor(public service: WebserviceService,
    private _message: MessageService,
    public router: Router,
    private _common: CommonService,
    private modalService: BsModalService,
    private actRoute: ActivatedRoute) { super(document);}

  ngOnInit(): void {
    this.user = (localStorage.getItem(`${this.env.panel}user`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}user`) as any) : {};
    this.uId = this.actRoute.snapshot.paramMap.get('uid');
    this.tId = this.actRoute.snapshot.paramMap.get('tid');
    this.key = this.actRoute.snapshot.paramMap.get('key');
    // if(this.actRoute.snapshot.paramMap.get('key')) { 
    //   this.getData(this.actRoute.snapshot.paramMap.get('key'));
    // } else {
    this.getData('');
    // }

  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getData(url: any, e: any = '') {
    // console.log(e);
    let key: any = (this.actRoute.snapshot.paramMap.get('key')) ? this.actRoute.snapshot.paramMap.get('key') : e;
    let uid: any = (this.actRoute.snapshot.paramMap.get('key')) ? this.user.id : this.actRoute.snapshot.paramMap.get('uid');
    let apiUrl = '';
    if (this.actRoute.snapshot.paramMap.get('tid')) {
      apiUrl = `${this.env.baseUrl + this.api.user}/${this.user?.id + this.api.childByType}/${this.actRoute.snapshot.paramMap.get('tid')}${(key && key.length > 2) ? '/' + key : ''}`;
    } else if (this.actRoute.snapshot.paramMap.get('uid')) {
      if (this.router.url.includes('blocked')) {
        apiUrl = `${this.env.baseUrl + this.api.user}/${uid}${this.api.blockChild}${(key && key.length > 2) ? '/' + key : ''}`;
      } else {
        apiUrl = `${this.env.baseUrl + this.api.myChilds}/${uid}${(key && key.length > 2) ? '/' + key : ''}`;
      }
    }

    apiUrl = url == '' ? apiUrl : url;
    // apiUrl = `https://jarvisexch.com/api/backend/users/child/8997/Abu735`
    const sub1 = this.getServices().Get(apiUrl).subscribe(
      (res) => {
        if (res.status == true) {
          this.data = res.data;
        } else {
          this._common.checkForForceChangePassword(res);
        }
      },
      (err) => {
        console.log(err);
      });
    this.subs.push(sub1)
  }
  update(e: any, uid: any) {
    let updateKey = (e.includes('status')) ? this.api.updateStatus : (e.includes('bet')) ? this.api.updateBetLock : (e.includes('delete')) ? this.api.updateRemove : (e.includes('password')) ? this.api.resetPassword : '';
    const sub2 = this.getServices().Get(`${this.env.baseUrl + this.api.user}/${uid}${updateKey}`).subscribe(
      (res) => {
        if (res.status == true) {
          this.getData('');
          let msg = (e.includes('bet')) ? res?.error?.message : res?.data?.message
          Swal.fire(
            msg,
            '',
            'success'
          )
        } else {
          if (res.error.code == 1003) {
            this._common.checkForForceChangePassword(res);
          } else {
            this._message.errmessage(res?.error?.message);
          }
        }
      },
      (err) => {
        console.log(err);
      });
    this.subs.push(sub2)
  }

  confirmBox(key: any, item: any) {
    let msg = (key == 'status-l') ? 'User Will Be Inactive' : (key == 'status-ul') ? 'User Will Be Active' : (key == 'bet-l') ? 'Bet Will Be Locked For This User!' : (key == 'bet-ul') ? 'Bet Will Be Open For This User!' : (key == 'delete') ? 'User Will Be Remove !' : (key == 'password') ? `Password of ${item.username} will be reset to 123456!` : '';
    Swal.fire({
      title: 'ARE YOU SURE?',
      text: msg,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancle'
    }).then((result) => {
      if (result.value) {
        this.update(key, item.id);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Cancelled',
          '',
          'error'
        )
      }
    })
  }

  openModal(template: TemplateRef<any>, id: any, key: any, name: any) {
    this.modalRef = this.modalService.show(template, Object.assign({}, { class: `${this.env.modalClass}` }));
    // this.editModal?.show();
    // if (id == 'ep') {
    this.updateProfileName = name;
    this.updateProfileId = id;

    // }
  }

  // openEditModal(id: any) {
  //   this.editModal?.show();
  //   this.updateProfileId = id;
  // }

  closeModal(e: any) {
    this.modalRef?.hide();
    if (e.key == 'ep')
      this.updateProfileId = undefined;
    if (e.status == true)
      this.getData('');
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  ngDoCheck() {
    if (this.uId != this.actRoute.snapshot.paramMap.get('uid') || this.tId != this.actRoute.snapshot.paramMap.get('tid') || this.key != this.actRoute.snapshot.paramMap.get('key')) {
      this.uId = this.actRoute.snapshot.paramMap.get('uid');
      this.tId = this.actRoute.snapshot.paramMap.get('tid');
      this.key = this.actRoute.snapshot.paramMap.get('key');
      this.data = undefined;
      this.getData('');
    }

  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

}
